import { render, staticRenderFns } from "./PaginaMostraOneriPersonale.vue?vue&type=template&id=2397fc8c"
import script from "./PaginaMostraOneriPersonale.vue?vue&type=script&lang=js"
export * from "./PaginaMostraOneriPersonale.vue?vue&type=script&lang=js"
import style0 from "./PaginaMostraOneriPersonale.vue?vue&type=style&index=0&id=2397fc8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports